<template>
  <div class="vm-block-album">
    <div
      class="fs20 fwb pl-0-16 pr-0-16 mq flex-box flex-justify-content-space-between flex-align-items-center"
      :class="{'white-bg': browser_size == 'small', pt16: browser_size == 'small',}"
      slot="tit"
    >
      <p class="flex-box flex-align-items-center">
        {{$t('c.BlockAlbum.text1')}}
        <tag v-if="is_hide_album" class="circle gray pt4 pb4 pr8 pl8 ml16 pointer" @click.native="tap">
          {{$t('c.BlockAlbum.text2')}}
        </tag>
      </p>
      <div class="right-text flex-box fwn fs16">
        <router-link v-if="is_self" class="purple gl-hover-text" :to="'/edit/album'">{{$t('c.BlockAlbum.text3')}}</router-link>
        <router-link class="purple gl-hover-text ml16" :to="`/a/${this_user.url_slug}/album`">
          {{$t('c.BlockAlbum.text4')}}
          <template
            v-if="this_user.creator && this_user.creator.album_count > 0"
          >（{{this_user.creator.album_count}}）</template>
        </router-link>
      </div>
    </div>
    <album-door
      v-if="has_album_load"
      class="pt16"
      :album_list="album_list"
      :has_create_btn="is_self ? true : false"
      :max="browser_size == 'small' ? 2 : 3"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { GET_CREATOR_GET_ALBUM_LIST } from '@/api/config';
export default {
  name: 'block-album',
  data() {
    return {
      has_album_load: false,
      album_list: [],
    };
  },
  computed: {
    ...mapState('app', ['session_user', 'browser_size']),
    ...mapState('user', ['this_user']),
    is_self() {
      return (
        this.session_user && this.this_user.user_id == this.session_user.user_id
      );
    },
    is_hide_album(){
      return (
        this.this_user && this.this_user.creator && this.this_user.creator.show_album == 0
      );
    }
  },
  watch: {},
  async mounted() {
    // await this.$store.dispatch("app/get:goal_list");
    // if (this.goal_list.length == 0) {
    // }
    if (this.this_user) {
      this.get_album_list();
    } else {
      console.log('缺少依赖this_user');
    }
  },
  methods: {
    async get_album_list() {
      if (this.$http.is_run(GET_CREATOR_GET_ALBUM_LIST)) {
        return false;
      }
      let data = await this.$http.$axios(GET_CREATOR_GET_ALBUM_LIST, {
        user_id: this.this_user.user_id,
        page: 1,
        per_page:10,
      });
      this.has_album_load = true;

      if (data.ec != 200) {
        this.$notify({
          title: data.em,
          group: 'error',
        });
        return false;
      }
      this.album_list = data.data.list;
    },
    tap(){
      this.$mixin_router_push(`/setting/creator`);
    },
  },
};
</script>

<style lang="stylus" scoped>
.vm-block-album {
  @media (max-width: $width-mobile) {
    .vm-album-door {
      background: $white;
    }
  }
}
</style>
